import { render, staticRenderFns } from "./SdkAddPersonId.vue?vue&type=template&id=c8d413fc&"
import script from "./SdkAddPersonId.vue?vue&type=script&lang=js&"
export * from "./SdkAddPersonId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports